import { event } from '@/api/app'
import { formatDate } from '../../utils';

const state = {
  localTime: '',
  localDate: '',
  appCountry: 'phl',
  appId: 'fresh',
  appNameDesc: 'freshapp',
  appVersion: '1.0.1',
  osVersion: 'test osVersion',
  deviceBrand: 'test',
  deviceModel: '',
  access: '',
  platformCode: 'H5',
  carrier: '',
  ipAddress: '',
  countryName: '',
  provinceName: '',
  cityName: '',
  appChannel: 'google_pay',
  utmComeFrom: '',
  isFirstDay: '',
  deviceId: '',
  userSoleId: '',
  reloanFlag: '',
  applyStateCode: '',
  eventCode: '',
  pageName: '',
  operationName: '',
  operationStatus: '',
  eventDuration: '',
  isLoading: false ,
  expandField:'',
}

const mutations = {
  setLoading(state, isLoading) {
    state.isLoading = isLoading;
  },
  setAppInfo(state, value) {
    Object.assign(state, value)
    localStorage.setItem('appInfo',JSON.stringify(value))
  }
}

const actions = {
  eventPoint({ state, commit }, pageinfo) {
    let appInfo = {};
    try {
      const appInfoStr = localStorage.getItem('appInfo');
      if (appInfoStr) {
        appInfo = JSON.parse(appInfoStr) || {};
      }
    } catch (_e) {
      // JSON.parse 失败时使用空对象，...{} 等价无展开
    }
    let stateParam = {
      ...state,
      localTime: Date.now(),
      localDate: formatDate(),
      ...appInfo
    }
    const params = {...stateParam, ...pageinfo}
    return new Promise((resolve, reject) => {
      event(params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  setAppInfo({ commit }, appInfo) {
    commit('setAppInfo', appInfo)
  },
  startLoading({ commit }) {
    commit('setLoading', true);
  },
  stopLoading({ commit }) {
    commit('setLoading', false);
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js